import isPromise from '@insight/toolkit-utils/lib/types/basic/isPromise';
import getInObject from '@insight/toolkit-utils/lib/helpers/getInObject';

import { publishFieldState } from '../internals';
import getValidators from './getValidators';
import clearAsyncValidationPromises from './clearAsyncValidationPromises';

const validateField = (state, field, setError) => {
  const { asyncValidationPromises, fields, formState } = state;
  const promises = [];

  const validators = getValidators(field);
  if (validators.length) {
    let error;
    validators.forEach((validator) => {
      const errorOrPromise = validator(
        getInObject(formState.values, field.name),
        formState.values,
        validator.length === 3
          ? publishFieldState(formState, fields[field.name])
          : undefined
      );

      if (errorOrPromise && isPromise(errorOrPromise)) {
        const asyncValidationKey = state.nextAsyncValidationKey++;
        const promise = errorOrPromise
          .then(setError)
          .then(clearAsyncValidationPromises(asyncValidationKey));
        promises.push(promise);
        asyncValidationPromises[asyncValidationKey] = promise;
      } else if (!error) {
        error = errorOrPromise;
      }
    });
    setError(error);
  }

  return promises;
};

export default validateField;
